import { useQuery } from '@tanstack/react-query';
import get from 'lodash/get';
import * as ResultModule from 'modules/result';

export type AttemptCountStatus = 'completed' | 'in_progress';

/**
 * How many attempts one test has, optionally by status. The test itself carries
 * no attempt stats, so this asks the results API for a one-row page and reads
 * its total. Returns undefined while disabled or loading.
 */
export function useAttemptCount(
  testId: string | undefined,
  status: AttemptCountStatus | undefined,
  enabled: boolean,
): number | undefined {
  const on = enabled && Boolean(testId);
  const { data } = useQuery({
    queryKey: ['result', 'count', testId, status ?? 'all'],
    queryFn: async () => {
      const { data: res } = await ResultModule.Api.List({ testId, status, perPage: 1 });
      return Number(get(res, 'data.meta.total')) || 0;
    },
    enabled: on,
    staleTime: 30_000,
  });
  return on ? data : undefined;
}

export default useAttemptCount;
